/**
 * Entry point React SPA.
 *
 * Boota providers (TanStack Query + Router), monta el shell con brand Champe.
 */
import './styles/globals.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found in index.html')
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
